// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"eX-z","sponsoredTooltipWrapper":"fX-z","sponsoredTooltip":"gX-z","newCard":"hX-z"};